let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iVLHX")).then(() => parcelRequire('7DYe9'));